export default "__VITE_ASSET__haaE3C5N__"